import { useListResourceGroupsQuery } from '@/queries/resourceGroups.queries';
import IEventType from '@/types/IEventType';
import { useDisclosure } from '@chakra-ui/react';
import { useIsFetching, useIsMutating } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

interface IProps {
	eventType: IEventType;
	onChange: (change: Partial<IEventType>) => void;
}

export function useRoundRobinParticipants(props: IProps) {
	const isMutation = useIsMutating() > 0;
	const isFetching = useIsFetching() > 0;
	const { t } = useTranslation();
	const disclosure = useDisclosure();
	const query = useListResourceGroupsQuery();
	const hasGroups = props.eventType.resourceRules?.availableInGroups?.length

	function handleRemoveGroup(id: string) {
		return props.onChange({
			resourceRules: {
				linkedResources: props.eventType.resourceRules?.linkedResources,
				availableInGroups: props.eventType.resourceRules?.availableInGroups?.filter((rg) => rg.group.id !== id),
			},
		});
	}

	return {
		handleRemoveGroup,
		query,
		disclosure,
		t,
		isLoading: isFetching || isMutation,
		hasGroups,
	};
}
